import { render, staticRenderFns } from "./RouterChildView.vue?vue&type=template&id=668759ae&"
import script from "./RouterChildView.vue?vue&type=script&lang=ts&"
export * from "./RouterChildView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports